module.exports = __webpack_public_path__ + "images/6732c0137a7dab50b23daf1337fe2f30.svg";